'use client';

import { useCallback, useMemo, useState } from 'react';

import { Checkbox } from '@repo/ui/checkbox';

import { CourseCollection } from 'types/sanity.types';

import CourseListItem from 'components/course-list-item';

import { styles } from '.';

type TProps = {
  items?: CourseCollection[];
  //
  locale: string;
};

const FilteredList = (props: TProps) => {
  const { items, locale } = props;

  const [arePastCoursesShown, setArePastCoursesShown] = useState(false);

  const filterPastCourses = useCallback((items?: CourseCollection[]) => {
    if (!items) {
      return [];
    }

    return items.filter((item) => {
      if (!item.playDates || item.playDates.length === 0) {
        return true;
      }

      const latestDate = [...item.playDates]
        .map((p) => p.date)
        .filter((d): d is string => !!d)
        .sort()
        .at(-1);

      return latestDate ? new Date(latestDate) > new Date() : true;
    });
  }, []);

  const results = useMemo(
    () => (arePastCoursesShown ? (items ?? []) : filterPastCourses(items)),
    [arePastCoursesShown, filterPastCourses, items],
  );

  return (
    <div className="flex flex-col items-start">
      <div className="flex flex-row gap-x-4 py-4 mb-8 border border-black p-4">
        <Checkbox
          id="are-past-courses-shown"
          checked={arePastCoursesShown}
          onCheckedChange={(checked) => {
            setArePastCoursesShown(checked as any);
          }}
          className="cursor-pointer"
        />
        <label
          htmlFor="are-past-courses-shown"
          className="cursor-pointer -mt-1"
        >
          Toon voorbije cursussen
        </label>
      </div>
      <ul className={styles.list}>
        {results.map((item) => (
          <CourseListItem key={item._id} item={item} locale={locale} />
        ))}
      </ul>
    </div>
  );
};

export default FilteredList;
